module.exports = __webpack_public_path__ + "static/media/171.7c9014d7.mp3";